// Shared column, filter, and globalFilterFields definitions for ModuleGrids
import { FilterMatchMode } from "primereact/api";
import {
  projectIdCell,
  projectNameCell,
  bufferToWorkCell,
  helpNeededCell,
  statusCell,
  statusIconCell,
  artworkStatusCell,
  filePathImageCell,
  cicImage,
  tooltipCell,
  taskNameCell,
} from "../CommonGrid/cellTemplates";
import { useDispatch } from "react-redux";
import { SpecialProjectAction } from "../../../store/actions/ProjectSetupActions";

// Helper to get baseUrl for each grid type
export const getBaseUrl = (type) => {
  switch (type) {
    case "project":
      return window.location.origin + "/allProjects";
    case "task":
      return window.location.origin + "/allTasks";
    default:
      return window.location.origin + "/allProjects";
  }
};

// ProjectGrid columns, filters, globalFilterFields
export const getProjectGridColumns = (mode, dispatch) => {
  const baseUrl = getBaseUrl("project");
  return [
    {
      field: "AWMProjectID",
      header: "Project ID",
      width: mode === "max" ? "12rem" : "120px",
      frozen: true,
      body: projectIdCell?.(baseUrl, dispatch, SpecialProjectAction),
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter ID" : undefined,
    },
    {
      field: "ProjectName",
      header: "Project Name",
      width: mode === "max" ? "22rem" : "270px",
      body: projectNameCell?.(baseUrl),
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter name" : undefined,
    },
    {
      field: "Category",
      header: "Category",
      width: mode === "max" ? "16rem" : "150px",
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter category" : undefined,
    },
    {
      field: "BufferToWork",
      header: "B:W",
      width: mode === "max" ? "8rem" : "120px",
      body: bufferToWorkCell,
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter B:W" : undefined,
    },
    {
      field: "Artwork_Status",
      header: "Artwork Status",
      width: mode === "max" ? "12rem" : "80px",
      body: artworkStatusCell?.(baseUrl),
    },
  ];
};
export const projectGridFilters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  AWMProjectID: { value: null, matchMode: FilterMatchMode.CONTAINS },
  ProjectName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  Category: { value: null, matchMode: FilterMatchMode.CONTAINS },
  BufferToWork: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
export const projectGridGlobalFilterFields = [
  "AWMProjectID",
  "ProjectName",
  "Category",
  "BufferToWork",
];

// TaskGrid columns, filters, globalFilterFields
export const getTaskGridColumns = (mode, dispatch, handleApproveDialogCPPFA) => {
  const baseUrl = getBaseUrl("task");
  return [
    {
      field: "TaskName",
      header: "Task Name",
      width: mode === "max" ? "18rem" : "250px",
      body: taskNameCell("TaskName", handleApproveDialogCPPFA),
      frozen: true,
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter Task Name" : undefined,
    },
    {
      field: "AWMProjectID",
      header: "Project ID",
      width: mode === "max" ? "12rem" : "150px",
      body: projectIdCell?.(baseUrl, dispatch, SpecialProjectAction),
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter Project ID" : undefined,
    },
    {
      field: "ProjectName",
      header: "Project Name",
      width: mode === "max" ? "20rem" : "250px",
      sortable: mode === "max",
      body: projectNameCell?.(baseUrl),
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter Project Name" : undefined,
    },
    {
      field: "Status",
      header: "Status",
      width: mode === "max" ? "12rem" : "120px",
      body: statusCell,
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter Status" : undefined,
    },
    {
      field: "HelpNeeded",
      header: "Help",
      width: mode === "max" ? "14rem" : "140px",
      body: helpNeededCell?.(mode),
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter Help" : undefined,
    },
    {
      field: mode === "max" ? "BufferToWork" : "AWM_BufferToWork",
      header: "B:W",
      width: mode === "max" ? "8rem" : "120px",
      body: bufferToWorkCell,
      sortable: mode === "max",
    },
    {
      field: "Assignee",
      header: "Assignee",
      width: mode === "max" ? "14rem" : "150px",
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter Assignee" : undefined,
    },
    {
      field: "LateTask",
      header: "LateTask",
      hidden: true,
    },
  ];
};
export const taskGridFilters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  TaskName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  AWMProjectID: { value: null, matchMode: FilterMatchMode.CONTAINS },
  ProjectName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  Status: { value: null, matchMode: FilterMatchMode.CONTAINS },
  HelpNeeded: { value: null, matchMode: FilterMatchMode.CONTAINS },
  BufferToWork: { value: null, matchMode: FilterMatchMode.CONTAINS },
  Assignee: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
export const taskGridGlobalFilterFields = [
  "TaskName",
  "AWMProjectID",
  "ProjectName",
  "Status",
  "HelpNeeded",
  "BufferToWork",
  "Assignee",
];

// FullkitGrid columns, filters, globalFilterFields
export const getFullkitGridColumns = (mode) => {
  const baseUrl = getBaseUrl("project");
  return [
    {
      field: "PiFPCID",
      header: "PI FPC",
      width: mode === "max" ? "10rem" : "100px",
      body: tooltipCell("PiFPCID"),
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter PI" : undefined,
    },
    {
      field: "PIMaterialNumber",
      header: "PI PMP",
      width: mode === "max" ? "10rem" : "100px",
      body: tooltipCell("PIMaterialNumber"),
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter PI" : undefined,
    },
    {
      field: "POANumber",
      header: "POA",
      width: mode === "max" ? "10rem" : "100px",
      body: tooltipCell("POANumber"),
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter POA" : undefined,
    },
    {
      field: "FAFlag",
      header: "FA",
      width: mode === "max" ? "10rem" : "100px",
      sortable: mode === "max",
      filter: mode === "max",
      body: cicImage,
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter FA" : undefined,
    },
    {
      field: "CICFlag",
      header: "CIC",
      width: mode === "max" ? "10rem" : "100px",
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter CIC" : undefined,
      body: cicImage,
    },
    {
      field: "AWMProjectID",
      header: "Project ID",
      width: mode === "max" ? "12rem" : "150px",
      frozen: true,
      body: projectIdCell?.(baseUrl),
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter ID" : undefined,
    },
    {
      field: "AWMProjectName",
      header: "Project Name",
      width: mode === "max" ? "20rem" : "250px",
      body: projectNameCell?.(baseUrl),
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter name" : undefined,
    },
    {
      field: "BufferToWork",
      header: "B:W",
      width: mode === "max" ? "8rem" : "120px",
      body: bufferToWorkCell,
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter B:W" : undefined,
    },
  ];
};
export const fullkitGridFilters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  AWMProjectID: { value: null, matchMode: FilterMatchMode.CONTAINS },
  AWMProjectName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  PiFPCID: { value: null, matchMode: FilterMatchMode.CONTAINS },
  PIMaterialNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
  POANumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
  FAFlag: { value: null, matchMode: FilterMatchMode.CONTAINS },
  CICFlag: { value: null, matchMode: FilterMatchMode.CONTAINS },
  BufferToWork: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
export const fullkitGridGlobalFilterFields = [
  "AWMProjectID",
  "AWMProjectName",
  "PiFPCID",
  "PIMaterialNumber",
  "POANumber",
  "FAFlag",
  "CICFlag",
  "BufferToWork",
];

// JobsGrid columns, filters, globalFilterFields
export const getJobsGridColumns = (mode) => {
  const baseUrl = getBaseUrl("project");
  return [
    {
      field: "FilePath",
      header: "Visual",
      width: mode === "max" ? "10rem" : "100px",
      frozen: true,
      body: filePathImageCell,
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter Visual" : undefined,
    },
    {
      field: "DesignJobName",
      header: "Job Name",
      width: mode === "max" ? "18rem" : "200px",
      body: tooltipCell("DesignJobName"),
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter Job Name" : undefined,
    },
    {
      field: "AWMProjectID",
      header: "Project ID",
      width: mode === "max" ? "12rem" : "150px",
      body: projectIdCell?.(baseUrl),
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter ID" : undefined,
    },
    {
      field: "ProjectName",
      header: "Project Name",
      width: mode === "max" ? "20rem" : "250px",
      body: projectNameCell?.(baseUrl),
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter name" : undefined,
    },
    {
      field: "Status",
      header: "Status",
      width: mode === "max" ? "12rem" : "120px",
      body: statusIconCell,
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter Status" : undefined,
    },
    {
      field: "BufferToWork",
      header: "B:W",
      width: mode === "max" ? "10rem" : "100px",
      body: bufferToWorkCell,
      sortable: mode === "max",
      filter: mode === "max",
      showFilterMenu: mode === "max",
      filterPlaceholder: mode === "max" ? "Filter B:W" : undefined,
    },
    {
      field: "Type",
      header: "Type",
      hidden: true,
    },
  ];
};
export const jobsGridFilters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  FilePath: { value: null, matchMode: FilterMatchMode.CONTAINS },
  DesignJobName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  AWMProjectID: { value: null, matchMode: FilterMatchMode.CONTAINS },
  ProjectName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  Status: { value: null, matchMode: FilterMatchMode.CONTAINS },
  BufferToWork: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
export const jobsGridGlobalFilterFields = [
  "FilePath",
  "DesignJobName",
  "AWMProjectID",
  "ProjectName",
  "Status",
  "BufferToWork",
];

// AlertsGrid columns, filters, globalFilterFields
export const getAlertsGridColumns = (mode) => {
  const baseUrl = getBaseUrl("project");
  return [
    {
      field: "PIMaterialNumber",
      header: "PI Material Number",
      width: mode === "max" ? "10rem" : "100px",
      body: tooltipCell("PIMaterialNumber"),
    },
    {
      field: "FPCID",
      header: "PI FPC Number",
      width: mode === "max" ? "10rem" : "100px",
      body: tooltipCell("FPCID"),
    },
    {
      field: "POANumber",
      header: "POA (RTA)",
      width: mode === "max" ? "10rem" : "100px",
      body: tooltipCell("POANumber"),
    },
    {
      field: "AlertType",
      header: "Alert Type",
      width: mode === "max" ? "14rem" : "140px",
      body: tooltipCell("AlertType"),
    },
    {
      field: "AWMProjectID",
      header: "Project ID",
      width: mode === "max" ? "12rem" : "150px",
      body: projectIdCell(baseUrl),
    },
    {
      field: "ProjectName",
      header: "Project Name",
      width: mode === "max" ? "20rem" : "250px",
      body: projectNameCell(baseUrl),
    },
    {
      field: "BufferToWork",
      header: "B:W",
      width: mode === "max" ? "8rem" : "120px",
      body: bufferToWorkCell,
    },
  ];
};

export const alertsGridFilters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  PIMaterialNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
  FPCID: { value: null, matchMode: FilterMatchMode.CONTAINS },
  POANumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
  AlertType: { value: null, matchMode: FilterMatchMode.CONTAINS },
  AWMProjectID: { value: null, matchMode: FilterMatchMode.CONTAINS },
  ProjectName: { value: null, matchMode: FilterMatchMode.CONTAINS },
};

export const alertsGridGlobalFilterFields = [
  "PIMaterialNumber",
  "FPCID",
  "POANumber",
  "AlertType",
  "AWMProjectID",
  "ProjectName",
];

// HelpNeededGrid columns, filters, globalFilterFields
export const getHelpNeededGridColumns = (mode) => [
  {
    field: "TaskName",
    header: "Task Name",
    body: tooltipCell("TaskName"),
    width: mode === "max" ? "18rem" : "250px",
  },
  {
    field: "AWMProjectID",
    header: "Project ID",
    body: projectIdCell(getBaseUrl("project")),
    width: mode === "max" ? "12rem" : "150px",
  },
  {
    field: "ProjectName",
    header: "Project Name",
    body: projectNameCell(getBaseUrl("project")),
    width: mode === "max" ? "20rem" : "250px",
  },
  {
    field: "Category",
    header: "Category",
    width: mode === "max" ? "16rem" : "150px",
  },
  { field: "Assignee", header: "Assignee", width: mode === "max" ? "14rem" : "150px" },
  {
    field: "BufferToWork",
    header: "B:W",
    body: bufferToWorkCell,
    width: mode === "max" ? "8rem" : "120px",
  },
];

export const helpNeededGridFilters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  TaskName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  AWMProjectID: { value: null, matchMode: FilterMatchMode.CONTAINS },
  ProjectName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  Category: { value: null, matchMode: FilterMatchMode.CONTAINS },
  Assignee: { value: null, matchMode: FilterMatchMode.CONTAINS },
  BufferToWork: { value: null, matchMode: FilterMatchMode.CONTAINS },
};

export const helpNeededGridGlobalFilterFields = [
  "TaskName",
  "AWMProjectID",
  "ProjectName",
  "Category",
  "Assignee",
  "BufferToWork",
];
